
loadPosts(); // Load all posts first

function loadPosts(element) {
	$('#loading').css('display', 'block'); // show loading text

	let category = '';
	let tag = '';
	let active = '';

	if(element) {

		if(element.hasClass('cat-filter-call')) { // If you press category
	    	category = element.data('category-id');
		}

		if(category.length === 0) {
			category = element.data('parent-category-id');
		}

		if(element.hasClass('tag-filter-call')) { // If you press tag
	    	tag = element.data('tag-slug');
		}


        if ($(element[0]).hasClass('active')) { // If we click on an active tag, we want to go back to active "category" and unfilter the current tag
        	active = 'active'; // for active class on the button
        	category = $(element[0]).data('parent-category-id'); // Get category we want to display when we unfilter
        	tag = ''; // empty tag cus we dont want to filter for any tag now since we unchecked it
        	$(element[0]).removeClass('active');
        }

	}

	jQuery.ajax({
	    url: horizon.ajaxUrl,
	    type: 'post',
	    data: {
	        action: 'data_fetch',
	        category: category,
	        active: active, // active class for button
			lang: horizon.lang,
	        tag: tag
	    },
	    success: function(data) {
	        $('#loading').css('display', 'none'); // hide loading text on succcess
	        jQuery('#datafetch').html(data); // Show new AJAX data
	    }
	});
}

// On filter button click filter between.
$('#ajax-container').on('click', '.cat-filter-call, .tag-filter-call', function() {
	var element = $(this);
	loadPosts(element);
});

// Radio button active class
$('.label-container').on('click', function() {
	$('.label-container').removeClass('active');
	$(this).addClass('active');
});
